import { BreakpointValue } from 'consts/breakpoints';

export const rangeToGalleryHeight: Record<BreakpointValue, number> = {
  1: 260,
  2: 400,
  3: 400,
  4: 400,
  5: 400,
};
